import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box,
  Avatar,
  useTheme
} from '@mui/material';
import { usePet } from '../context/usePet';
import PetsIcon from '@mui/icons-material/Pets';

export function ModalDelete() {
  const theme = useTheme();
  const { 
    isDeleteModalOpen, 
    selectedPet, 
    closeDeleteModal, 
    handleDeletePet, 
    isDeleting 
  } = usePet();

  if (!selectedPet) return null;

  return (
    <Dialog 
      open={isDeleteModalOpen} 
      onClose={closeDeleteModal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={600}>
          Confirmar Exclusão
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Avatar 
            src={selectedPet.foto} 
            sx={{ width: 60, height: 60, bgcolor: '#E0E7EF' }}
          >
            <PetsIcon sx={{ fontSize: 30, color: '#9CA3AF' }} />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={600} color={theme.palette.text.primary}>
              {selectedPet.nome}
            </Typography>
            <Typography variant="body2" color={theme.palette.text.secondary}>
              {selectedPet.raca} • {selectedPet.tipo}
            </Typography>
          </Box>
        </Box>
        
        <Typography variant="body1" color={theme.palette.text.primary}>
          Tem certeza que deseja excluir este pet? Esta ação não pode ser desfeita.
        </Typography>
        
        <Box sx={{ mt: 2, p: 2, bgcolor: '#FEF2F2', borderRadius: 1, border: '1px solid #FECACA' }}>
          <Typography variant="body2" color="#DC2626" fontWeight={500}>
            ⚠️ Atenção: Todos os dados relacionados a este pet serão permanentemente removidos.
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={closeDeleteModal} 
          disabled={isDeleting}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button 
          onClick={handleDeletePet} 
          disabled={isDeleting}
          variant="contained" 
          color="error"
          sx={{ 
            bgcolor: '#DC2626',
            '&:hover': {
              bgcolor: '#B91C1C'
            }
          }}
        >
          {isDeleting ? 'Excluindo...' : 'Excluir Pet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
} 